export type AIBillingTabHash =
  | "AIAssistantConfiguration"
  | "AIAgentUsage"
  | "AIAgentUsageDetail";

export function navigateToAIBillingTab(hash: AIBillingTabHash): void {
  if (window.location.hash.substring(1) === hash) {
    return;
  }
  window.location.hash = hash;
}
